import createKeys from '../../utilities/createKeys'

export const Keys = createKeys('CATEGORIES', ['MODAL_FORM', 'BUTTON_NEW'])
